<template>
  <div v-if="statisticsOrder">
    <b-row class="content-header mb-2">
      <!-- Content Left -->
      <b-col class="content-header-left" cols="12" md="9">
        <breadcrumb />

      </b-col>
    </b-row>

    <b-row>
      <div class="bg-white p-2 rounded-lg shadow-sm">
        <strong style="padding: 10px 0;font-size: 15px;margin: 10px 0">
          آمار 7 روز گذشته، درخواست های رزرو
        </strong>
        <hr/>
        <div class="d-flex">
          <div class="pr-1">
            <strong>مجموع تعداد درخواست  :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.orders_last_seven_total_count}}

            </b-badge>
            <span>
              درخواست
            </span>
          </div>
        </div>
        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>مجموع تعداد درخواست موفق  :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.orders_last_seven_total_paid}}

            </b-badge>
            <span>
              نفر
            </span>
          </div>
        </div>


        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>مجموع تعداد مهمان  :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.orders_last_seven_total_guest}}

            </b-badge>
            <span>
              نفر
            </span>
          </div>
        </div>


        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>مجموع پرداختی به سایت در رزروهای موفق   :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{numberFormat(statisticsOrder.orders_last_seven_total_prices_paid)}}

            </b-badge>
            <span>
              تومان
            </span>
          </div>
        </div>
        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>بیشترین تعداد درخواست رزرو   :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.user_with_most_orders_last_7_days.full_name}}
            </b-badge>
            <b-badge class="ml-1" variant="primary">
              {{statisticsOrder.user_with_most_orders_last_7_days.mobile.replace("+98", "0") }}
            </b-badge>
            <span>
               به تعداد
            </span>
            <b-badge variant="success">
              {{statisticsOrder.user_with_most_orders_last_7_days.order_count}}
            </b-badge>
            <span>
              درخواست
            </span>
          </div>
        </div>

        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>بیشترین تعداد درخواست رزرو موفق   :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.user_with_most_orders_last_7_days_paid.full_name}}
            </b-badge>
            <b-badge class="ml-1" variant="primary">
              {{statisticsOrder.user_with_most_orders_last_7_days_paid.mobile.replace("+98", "0") }}
            </b-badge>
            <span>
               به تعداد
            </span>
            <b-badge variant="success">
              {{statisticsOrder.user_with_most_orders_last_7_days_paid.order_count}}
            </b-badge>
            <span>
              درخواست
            </span>
          </div>
        </div>
        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>بیشترین تعداد درخواست ها در بین خدمات   :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="info">
              {{statisticsOrder.most_ordered_product_last_7_days.name}}
            </b-badge>
            <span>
               به تعداد
            </span>
            <b-badge variant="info">
              {{statisticsOrder.most_ordered_product_last_7_days.order_count}}
            </b-badge>
            <span>
              درخواست
            </span>
          </div>
        </div>

        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>بیشترین تعداد درخواست ها رزروهای موفق در بین خدمات   :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="info">
              {{statisticsOrder.most_ordered_product_last_7_days_paid.name}}
            </b-badge>
            <span>
               به تعداد
            </span>
            <b-badge variant="info">
              {{statisticsOrder.most_ordered_product_last_7_days_paid.order_count}}
            </b-badge>
            <span>
              درخواست
            </span>
          </div>
        </div>
      </div>
    </b-row>

    <b-row class="my-2">
      <div class="bg-white p-2 rounded-lg shadow-sm">
        <strong style="padding: 10px 0;font-size: 15px;margin: 10px 0">
          آمار 30 روز گذشته، درخواست های رزرو
        </strong>
        <hr/>
        <div class="d-flex">
          <div class="pr-1">
            <strong>مجموع تعداد درخواست  :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.orders_last_month_total_count}}

            </b-badge>
            <span>
              درخواست
            </span>
          </div>
        </div>
        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>مجموع تعداد درخواست موفق  :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.orders_last_month_total_paid}}

            </b-badge>
            <span>
              نفر
            </span>
          </div>
        </div>


        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>مجموع تعداد مهمان  :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.orders_last_month_total_guest}}

            </b-badge>
            <span>
              نفر
            </span>
          </div>
        </div>


        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>مجموع پرداختی به سایت در رزروهای موفق   :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{numberFormat(statisticsOrder.orders_last_month_total_prices_paid)}}

            </b-badge>
            <span>
              تومان
            </span>
          </div>
        </div>
        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>بیشترین تعداد درخواست رزرو   :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.user_with_most_orders_last_month_days.full_name}}
            </b-badge>
            <b-badge class="ml-1" variant="primary">
              {{statisticsOrder.user_with_most_orders_last_month_days.mobile.replace("+98", "0") }}
            </b-badge>
            <span>
               به تعداد
            </span>
            <b-badge variant="success">
              {{statisticsOrder.user_with_most_orders_last_month_days.order_count}}
            </b-badge>
            <span>
              درخواست
            </span>
          </div>
        </div>

        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>بیشترین تعداد درخواست رزرو موفق   :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="success">
              {{statisticsOrder.user_with_most_orders_last_month_days_paid.full_name}}
            </b-badge>
            <b-badge class="ml-1" variant="primary">
              {{statisticsOrder.user_with_most_orders_last_month_days_paid.mobile.replace("+98", "0") }}
            </b-badge>
            <span>
               به تعداد
            </span>
            <b-badge variant="success">
              {{statisticsOrder.user_with_most_orders_last_month_days_paid.order_count}}
            </b-badge>
            <span>
              درخواست
            </span>
          </div>
        </div>
        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>بیشترین تعداد درخواست ها در بین خدمات   :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="info">
              {{statisticsOrder.most_ordered_product_last_month_days.name}}
            </b-badge>
            <span>
               به تعداد
            </span>
            <b-badge variant="info">
              {{statisticsOrder.most_ordered_product_last_month_days.order_count}}
            </b-badge>
            <span>
              درخواست
            </span>
          </div>
        </div>

        <div class="d-flex my-1">
          <div class="pr-1">
            <strong>بیشترین تعداد درخواست ها رزروهای موفق در بین خدمات   :</strong>
          </div>
          <div class="mr-2">
            <b-badge variant="info">
              {{statisticsOrder.most_ordered_product_last_month_paid.name}}
            </b-badge>
            <span>
               به تعداد
            </span>
            <b-badge variant="info">
              {{statisticsOrder.most_ordered_product_last_month_paid.order_count}}
            </b-badge>
            <span>
              درخواست
            </span>
          </div>
        </div>
      </div>
    </b-row>

  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BAvatar,
  BButton,
  BSpinner,
  BSidebar,
  BContainer,
  BFormTextarea,
  BFormRadio, BBadge,
} from "bootstrap-vue";
import PerPage from "@/components/PerPage.vue";
import Breadcrumb from "@/components/Breadcrumb.vue";
import Pagination from "@/components/Pagination.vue";
import Search from "@/components/Search.vue";
import TableHead from "@/components/TableHead.vue";
import vSelect from "vue-select";
import StatisticCardVertical from "@core/components/statistics-cards/StatisticCardVertical.vue";

export default {
  components: {
    BBadge,
    StatisticCardVertical,
    BRow,
    BCol,
    PerPage,
    BFormGroup,
    BFormInput,
    BCard,
    BAvatar,
    BButton,
    Breadcrumb,
    Pagination,
    Search,
    TableHead,
    BSpinner,
    BSidebar,
    BContainer,
    BFormTextarea,
    vSelect,
    BFormRadio
  },
  data() {
    return {
      perPage: 10,
      page: 1,
      statisticsOrder: [],
      residences: null,
      cars: null,
      tours: null,
      experiences: null,
      defaultAvatar: require("@/assets/images/avatars/default.png"),
      cancelToken: undefined,
      sortBy: "",
      sortDir: "",
      searchInput: "",
      paginationData: null,

      OpenIndicator: {
        render: (createElement) =>
            createElement("feather-icon", { attrs: { icon: "ChevronDownIcon" } }),
      },

      countryInput: {
        name: "",
        slug:"",
        status:"active"

      },
      editMode: false,
      formModal: false,
      submitLoading: false,
    };
  },
  mounted() {
    this.getStatisticsOrder();
  },

  methods: {
    numberFormat(number) {
      return  new Intl.NumberFormat().format(number)
    },
    async getStatisticsOrder() {
      this.cancelToken = this.$http.CancelToken.source();
      const requestData = {
        method: "get",
        url: "/admin/statistics/reports_orders",

      };
      this.$http(requestData)
          .then((response) => {
            let data = response.data;
            this.statisticsOrder = data.data;
          })
          .catch((err) => {
            console.log(err);
          });
    },




  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
